// In development: when app is served from localhost (e.g. :5000), use local Django API (:8000)
const isLocalDev =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1") &&
  (window.location.port === "5000" || window.location.port === "3000" || !window.location.port);

let config = {
  BASE_URL: isLocalDev ? "http://127.0.0.1:8000/" : "https://apipostman.onlinecu.in/",
  PRODUCTION_URL: "http://172.17.18.255:8080/",
};

export default config;
